import React, { useState, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { DialogBox } from 'components/Zui'
import { useIntl } from 'hooks'
import { generateAllForPayload, generateAllForQuery } from 'utils/helpers'
import { axiosApi } from 'services/api'
import {
    useGetCollectionsQuery,
    useAddCollectionMutation,
    useGetDisabledCollectionsQuery,
    useAddFilesToCollectionMutation,
} from 'services'
import { validationSchema } from 'schema/addToCollection'
import { validationSchema as createValidationSchema } from 'schema/collection'
import { collectionsNames } from 'features/collections-list/collectionSlice'
import { FormContainer } from 'components/Form'
import Modal from 'components/Modals'
import Form from './Form'
import './index.css'

const Index = ({ onClose, data, handleSelectFile }) => {
    const { t } = useIntl()
    const dispatch = useDispatch()
    const [create, setCreate] = useState(false)
    const [selected, setSelected] = useState([])
    const existingCollections = useSelector(collectionsNames)
    const { data: collections, isLoading: isCollectionLoading } = useGetCollectionsQuery()
    const { data: disabledCollections } = useGetDisabledCollectionsQuery(generateAllForQuery(data))

    const [createCollection, { isLoading: isCreating }] = useAddCollectionMutation()
    const [addFilesToCollection] = useAddFilesToCollectionMutation()

    const handleCreateCollection = ({ name }) => {
        createCollection({ name })
    }

    const handleAddToCollection = ({ collections }) => {
        const payload = {
            collectionIds: collections.join(),
            ...generateAllForPayload(data),
        }

        addFilesToCollection(payload)
        data.fileIds && handleSelectFile && handleSelectFile(false, data.fileIds)
        onClose()
    }

    const patchCollection = useCallback(
        () =>
            dispatch(
                axiosApi.util.updateQueryData('getCollections', undefined, draft => {
                    draft.forEach(element => {
                        if (element.isNew) element.isNew = false
                    })
                })
            ),
        []
    )

    return (
        <div>
            <Modal>
                <FormContainer
                    initialValues={{
                        name: '',
                        keyword: '',
                        collections: selected,
                        list: collections || [],
                        existingCollections,
                    }}
                    onSubmit={({ collections, name }) => {
                        if (create) {
                            setSelected(collections)
                            handleCreateCollection({ name })
                        } else {
                            handleAddToCollection({ collections })
                        }
                    }}
                    validationSchema={create ? createValidationSchema(t) : validationSchema(t)}
                    validateOnBlur={false}
                    enableReinitialize
                >
                    {formik => {
                        return (
                            <DialogBox
                                closable
                                headerText={t('add.to.collection')}
                                acceptLabel={t('add')}
                                cancelLabel={t('cancel')}
                                confirmPosition="right"
                                onClose={() => {
                                    patchCollection()
                                    onClose()
                                }}
                                onCancel={() => {
                                    patchCollection()
                                    onClose()
                                }}
                                onAccept={async () => {
                                    await setCreate(false)
                                    formik.handleSubmit()
                                }}
                            >
                                <Form
                                    collections={collections}
                                    isCollectionLoading={isCollectionLoading}
                                    disabledCollections={disabledCollections}
                                    setCreate={setCreate}
                                    isCreating={isCreating}
                                    {...formik}
                                />
                            </DialogBox>
                        )
                    }}
                </FormContainer>
            </Modal>
        </div>
    )
}

export default Index
